import { useParams } from "react-router-dom";
import { ToastProvider } from "../../../common/components/ui/toast/toast.provider";
import Dashboard from "../../../common/components/layout/Dashboard";
import Toast from "../../../common/components/ui/toast";
import { CommissionReportsDashboard } from "./components/commission-dashboard";
import { CommissionReportsDashboardProvider } from "./components/commission-dashboard/Commission.provider";

export default function CommissionReportsDetailsPage() {
  const { technicalConsultant } = useParams();

  return (
    <ToastProvider>
      <Dashboard>
        <CommissionReportsDashboardProvider technicalConsultant={technicalConsultant || ''}>
          <CommissionReportsDashboard />
        </CommissionReportsDashboardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}
